import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { httpClient } from 'helpers/HttpClient.js';
import WizardInput from 'componentes/wizard/WizardInput.js';
const URI = ApiEndpoint + 'operations/';
const URIConfig = ApiEndpoint + 'configuration/';
const CloseQueja = ({
  idQueja,
  closeModal,
  setErrorMesagge,
  setShowErrorMessage,
  setIsError,
  currentStatus
}) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [statuses, setStatuses] = useState(null);
  const [idStatus, setIdStatus] = useState(null);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const getStatuses = async () => {
    setStatuses(null);

    httpClient('GET', URIConfig + 'statusbytype/2', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          var customersList = response.data
            .filter(item => item.idstatus !== currentStatus)
            .map(item => {
              return { value: item.idstatus, label: item.descripcion };
            });
          setStatuses(customersList);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const onSubmit = data => {
    console.log(data);
    httpClient(
      'POST',
      URI + 'closequeja/' + idQueja,
      {
        status: idStatus,
        motivocierre: data.motivocierre
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          closeModal();
          setIsError(false);
          setErrorMesagge('Expediente Actualizado con exito');
          setShowErrorMessage(true);
        } else {
          setIsError(true);
          setErrorMesagge('Ha ocurrido un error al registrar el cierre');
          setShowErrorMessage(true);
        }
      })
      .catch(function (error) {
        console.log(error);
        setIsError(true);
        setErrorMesagge('Ha ocurrido un error al registrar el cierre');
        setShowErrorMessage(true);
      })
      .finally(() => {});
  };

  useEffect(() => {
    if (!statuses) getStatuses();
  }, []);

  return (
    <Card style={{ width: '100%' }}>
      <Card.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col>
              {statuses && (
                <WizardInput
                  label="Status"
                  type="select"
                  name="status"
                  errors={errors}
                  options={statuses}
                  onChange={e => {
                    setIdStatus(e.target.value);
                  }}
                  formGroupProps={{ className: 'mb-3' }}
                  formControlProps={{
                    ...register('status', { required: true })
                  }}
                />
              )}
            </Col>
          </Row>
          <Row className="g-2 mb-3">
            <WizardInput
              label="Motivo de Cierre"
              name="motivocierre"
              type="text"
              errors={errors}
              formGroupProps={{ className: 'mb-3' }}
              formControlProps={{
                ...register('motivocierre')
              }}
            />
          </Row>
          <Row>
            <Col>
              <Button type="submit" color="primary" size="sm">
                Guardar
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};
CloseQueja.propTypes = {
  idQueja: PropTypes.string.isRequired,
  closeModal: PropTypes.func,
  setErrorMesagge: PropTypes.func,
  setShowErrorMessage: PropTypes.func,
  setIsError: PropTypes.func,
  currentStatus: PropTypes.int
};
export default CloseQueja;
